import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      aria-label="Nach oben"
      onClick={go}
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-[#111111] text-white flex items-center justify-center shadow-[0_15px_30px_-10px_rgba(17,17,17,0.5)] hover:bg-black transition-all duration-300 ${
        show ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <ArrowUp className="w-4 h-4" strokeWidth={2.2} />
    </button>
  );
};

export default BackToTop;
